import { EventPanelForm, EventPanelFormType } from '@mark43/cad-api';
import { action, makeObservable, observable } from 'mobx';
import { PropertyBaseKey, EventPanelVehicleBaseKey } from '../involved-person-vehicle-fields/types';
import { EntityPanelFormPersonBaseKey } from '../../../panels/entity-panels/forms/types';

export type LocallyRemovedFieldKeyType = keyof Pick<
    EventPanelForm,
    EntityPanelFormPersonBaseKey | EventPanelVehicleBaseKey | PropertyBaseKey
>;

export type LocallyRemovedEventPanelFormFields = Record<LocallyRemovedFieldKeyType, number[]>;

export type LocallyRemovedEventPanelFormValues = Pick<
    EventPanelFormType,
    LocallyRemovedFieldKeyType
>;

export const getLocallyRemovedFieldsBaseValue = (): LocallyRemovedEventPanelFormFields => ({
    vehicles: [],
    mergedVehicles: [],
    towVehicles: [],
    mergedTowVehicles: [],
    reportingParties: [],
    mergedReportingParties: [],
    involvedPersons: [],
    mergedInvolvedPersons: [],
    firearms: [],
    mergedFirearms: [],
    drugs: [],
    mergedDrugs: [],
    otherItems: [],
    mergedOtherItems: [],
});

export class LocallyRemovedEventPanelFormFieldsStore {
    @observable
    public locallyRemovedFields: LocallyRemovedEventPanelFormFields = getLocallyRemovedFieldsBaseValue();

    constructor() {
        makeObservable(this);
    }

    @action
    public removeField(fieldType: keyof LocallyRemovedEventPanelFormFields, fieldValueId: number) {
        const newField = [...this.locallyRemovedFields[fieldType], fieldValueId];

        this.locallyRemovedFields = {
            ...this.locallyRemovedFields,
            [fieldType]: newField,
        };
    }

    @action
    public onUserSaveForm() {
        this.locallyRemovedFields = getLocallyRemovedFieldsBaseValue();
    }
}
